module.exports = {
          srcSet: __webpack_public_path__ + "2e16bdec34a738a4864fb023b0057f1c-360.png"+" 360w",
          images:[ {path: __webpack_public_path__ + "2e16bdec34a738a4864fb023b0057f1c-360.png",width: 360,height: 500}],
          src: __webpack_public_path__ + "2e16bdec34a738a4864fb023b0057f1c-360.png",
          toString:function(){return __webpack_public_path__ + "2e16bdec34a738a4864fb023b0057f1c-360.png"},
          
          width: 360,
          height: 500
        }